export  enum TipoUniversoEnum{
  Padronizado = 1,
  NaoPadronizado= 2
}
